export default __webpack_public_path__ + "static/media/modalDetailBgMb.1fda680b.png";